<template>
  <div class="container-fluid">
    <div class="card search-card">
      <div class="card-body">
        <div class="form-row">
          <div class="col-sm-3 col-md-2">
            <div class="form-group">
              <label for="search-role-name">{{ i18n("Role.RoleName") }}</label>
              <input
                type="text"
                id="search-role-name"
                class="form-control"
                placeholder="請輸入關鍵字"
                v-model.trim="roleName"
                @keydown.stop.prevent.enter="getRole()"
              />
            </div>
          </div>

          <div class="col-sm-3 col-md-3">
            <button
              type="button"
              class="btn btn-primary"
              style="margin-top: 30px; margin-left: 10px"
              @click="getRole()"
            >
              {{ i18n("Buttons.Search") }}
            </button>
            <button
              type="button"
              class="btn btn-primary"
              style="margin-top: 30px; margin-left: 10px"
              data-toggle="modal"
              data-target="#roleModal"
              @click="roleModal({ action: 'add' })"
            >
              {{ i18n("Buttons.AddRole") }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="yahome-table-wrap">
      <VueBootstrap4Table
        :rows="rows"
        :columns="columns"
        :config="config"
        :total-rows="totalData"
        @on-change-query="changePage"
      >
        <template slot="setMenu" slot-scope="props">
          <button
            type="button"
            class="btn btn-primary btn-sm"
            style="margin-right: 0.5rem"
            data-toggle="modal"
            data-target="#setPermissionsModal"
            @click="setPermissionsModal(props.row)"
          >
            {{ i18n("Role.SetUpPermission") }}
          </button>
        </template>
        <template slot="setUser" slot-scope="props">
          <button
            type="button"
            class="btn btn-success btn-sm"
            style="margin-right: 0.5rem"
            @click="setUserModal(props.row)"
          >
            {{ i18n("Role.SetUpEmployee") }}
          </button>
        </template>

        <template slot="edit" slot-scope="props">
          <button
            type="button"
            class="btn btn-info btn-sm"
            style="margin-right: 0.5rem"
            data-toggle="modal"
            data-target="#roleModal"
            @click="roleModal({ action: 'edit', data: props.row })"
          >
            {{ i18n("Buttons.Edit") }}
          </button>
        </template>

        <template slot="delete" slot-scope="props">
          <button
            type="button"
            class="btn btn-danger btn-sm"
            data-toggle="modal"
            data-target="#delRoleModal"
            @click="role = props.row"
          >
            {{ i18n("Buttons.Delete") }}
          </button>
        </template>
        <template slot="empty-results"> 暫無資料 </template>
      </VueBootstrap4Table>
    </div>

    <!-- 新增、編輯 Modal -->
    <div class="modal fade" id="roleModal" tabindex="-1" data-backdrop="static">
      <div class="modal-dialog modal-dialog-centered">
        <ValidationObserver
          ref="role"
          class="modal-content"
          v-slot="{ handleSubmit, reset }"
        >
          <form @reset.prevent="reset">
            <div class="modal-header">
              <span v-if="action === 'add'">{{ i18n("Role.AddRole") }}</span>
              <span v-else>{{ i18n("Role.EditRole") }}</span>
            </div>
            <div class="modal-body">
              <div class="field">
                <ValidationProvider
                  tag="div"
                  :name="i18n('Role.RoleName')"
                  :rules="`my_not:${nowRole.Name}|required`"
                  v-slot="{ errors }"
                >
                  <label for="input-role-name">
                    <span class="mark">*</span>{{ i18n("Role.RoleName") }}
                    <span class="mark">(不可重複)</span>
                  </label>
                  <input
                    type="text"
                    id="input-role-name"
                    class="form-control"
                    @compositionstart="is_composing = true"
                    @compositionend="is_composing = false"
                    v-model="role.Name"
                  />
                  <span v-if="errors[0] && !is_composing" class="text-danger">
                    {{ errors[0] }}
                  </span>
                </ValidationProvider>
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="reset"
                class="btn btn-secondary"
                data-dismiss="modal"
              >
                {{ i18n("Buttons.Cancel") }}
              </button>
              <button
                type="button"
                class="btn btn-success"
                @click="handleSubmit(saveRole)"
              >
                {{ i18n("Buttons.Save") }}
              </button>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </div>

    <!-- 設定權限 Modal -->
    <div
      class="modal fade"
      id="setPermissionsModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <form @submit.prevent="savePermissions">
            <div class="modal-header">
              <span>
                <span class="badge badge-primary" style="font-size: 15px">
                  {{ currentRole.Name }}
                </span>
                {{ i18n("Role.SetUpPermission") }}
              </span>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-sm-12 col-md-6" style="height: 55vh">
                  <perfect-scrollbar class="menu-select-list">
                    <div
                      v-for="(mainMenu, index) in menu"
                      :key="index"
                      :class="{ open: mainMenu.NewWindow }"
                    >
                      <div
                        class="menu-name"
                        @click="mainMenu.NewWindow = !mainMenu.NewWindow"
                      >
                        <span>
                          {{ mainMenu.MenuName }}
                        </span>
                        <eva-icon fill="#000" name="chevron-right-outline" />
                      </div>
                      <div class="option-wrap">
                        <div
                          v-for="(subMenu, index) in mainMenu.Children"
                          class="option"
                          :class="{
                            active: selectedSubMenuGuid === subMenu.Guid,
                            hasPermission:
                              subMenu.hasPermission &&
                              selectedSubMenuGuid !== subMenu.Guid,
                          }"
                          :key="index"
                          @click="getPermissions(subMenu)"
                        >
                          {{ subMenu.MenuName }}
                        </div>
                      </div>
                    </div>
                  </perfect-scrollbar>
                </div>
                <div class="col-sm-12 col-md-6">
                  <div
                    class="permission-select-list overflow-auto"
                    style="height: 55vh"
                  >
                    <label
                      v-for="(features, index) in subMenuPermissions"
                      :key="index"
                    >
                      <input v-model="features.IsSelected" type="checkbox" />
                      <span>{{ features.PermissionName }}</span>
                      <div class="switch">
                        <span></span>
                      </div>
                    </label>
                    <div v-if="subMenuPermissions.length <= 0">尚無功能</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-secondary"
                data-dismiss="modal"
              >
                {{ i18n("Buttons.Cancel") }}
              </button>
              <button
                type="button"
                class="btn btn-success"
                @click="getPermissionsGuid"
              >
                {{ i18n("Buttons.Save") }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <!-- 設定人員 Modal -->
    <div
      class="modal fade"
      id="setUserModal"
      tabindex="-1"
      data-focus="false"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered modal-xl">
        <div class="modal-content">
          <div class="modal-header">
            <span>
              <span class="badge badge-primary" style="font-size: 15px">
                {{ currentRole.Name }}
              </span>
              {{ i18n("Role.SetUpEmployee") }}
            </span>
          </div>
          <div class="modal-body">
            <kr-paging
              ref="krPaging"
              :boxTitle="['未選取人員', '已選取人員']"
              :filter-placeholder="['請輸入關鍵字', '請輸入關鍵字']"
              :pageTexts="['上一頁', '下一頁']"
              filterable
              isHighlight
              showClearBtn
              :pageSize="50"
              :dataList="leftUser"
              :selectedData="rightUser"
              @onChange="addEmployeeToRightUser"
            />
          </div>

          <div class="modal-footer">
            <button type="reset" class="btn btn-secondary" data-dismiss="modal">
              {{ i18n("Buttons.Cancel") }}
            </button>
            <button
              type="button"
              @click="setRolesToUser()"
              class="btn btn-success"
            >
              {{ i18n("Buttons.Save") }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- 刪除 Modal -->
    <div
      class="modal fade"
      id="delRoleModal"
      tabindex="-1"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">{{ i18n("Role.DeleteRole") }}</div>
          <div class="modal-body">
            確認刪除
            <span style="font-weight: bolder; color: red">
              {{ role.Name }} </span
            >?
          </div>
          <div class="modal-footer">
            <button type="reset" class="btn btn-secondary" data-dismiss="modal">
              {{ i18n("Buttons.Cancel") }}
            </button>
            <button
              type="button"
              class="btn btn-danger"
              data-dismiss="modal"
              @click="delRole"
            >
              {{ i18n("Buttons.Delete") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* global $ */
import { mapGetters, mapActions } from "vuex";
import { config } from "@/components/back/table_config.js";

export default {
  inject: ["reload"],
  name: "Role",
  data() {
    return {
      // compositionstart & compositionend
      is_composing: false,

      roleName: null,
      // 角色的Modal狀態
      isAddRole: false,

      // 判斷新增、編輯
      action: "add",

      // 角色名稱
      role: {},
      // 判斷角色名稱是否重複
      nowRole: {},

      // 左側人員列表
      leftUser: [],
      // 右側人員列表
      rightUser: [],

      // 已選取之人員
      selectedUser: [],

      currentRole: "",

      menu: [], // 選單列
      unfoldMainMenuGuid: null, // 目前展開的主選單Guid
      selectedSubMenuGuid: null, // 目前被點擊的子選單Guid
      subMenuPermissions: [], // 子選單擁有的功能
      selectedFeatureGuid: [], // 被選取功能的Guid

      rows: [],
      totalData: 0,

      // table data
      tableInfo: {
        // 分頁資訊
        page: 1,
        per_page: 10,
      },

      columns: [
        {
          label: this.i18n("Role.RoleName"),
          name: "Name",
        },
        {
          label: this.i18n("Role.Permission"),
          name: "setMenu",
          slot_name: "setMenu",
        },

        {
          label: this.i18n("Basic.Employee"),
          name: "setUser",
          slot_name: "setUser",
        },
        {
          label: "",
          slot_name: "edit",
        },
        {
          label: "",
          slot_name: "delete",
        },
      ],

      config: {
        ...config,
        server_mode: true,
      },
    };
  },

  computed: {
    ...mapGetters(["lang"]),
  },

  watch: {
    lang: function () {
      this.columns = [
        { label: this.i18n("Role.RoleName"), name: "Name" },
        {
          label: this.i18n("Role.Permission"),
          name: "setMenu",
          slot_name: "setMenu",
        },
        {
          label: this.i18n("Basic.Employee"),
          name: "setUser",
          slot_name: "setUser",
        },
        { label: "", slot_name: "edit" },
        { label: "", slot_name: "delete" },
      ];
    },

    unfoldMainMenuGuid: function (oldVal, newVal) {
      if (oldVal !== newVal) {
        this.selectedSubMenuGuid = null;
        this.subMenuPermissions = [];
      }
    },
  },

  methods: {
    // 分頁
    changePage(queryParams) {
      this.tableInfo = queryParams;
      this.getRole();
    },

    // 取得 角色
    getRole() {
      this.updateLoading(true);
      this.$api.role
        .getRolePaging({
          name: this.roleName,
          isPaging: true,
          page: this.tableInfo.page,
          perPage: this.tableInfo.per_page,
        })
        .then((response) => {
          if (response.status === 200) {
            this.rows = response.data.Datas;
            this.totalData = response.data.Quantity;
          }
          this.updateLoading(false);
        });
    },

    // 設定權限 Modal
    setPermissionsModal(row) {
      this.currentRole = row;
      this.menu = [];
      this.unfoldMainMenuGuid = null;
      this.selectedSubMenuGuid = null;
      this.subMenuPermissions = [];
      this.selectedFeatureGuid = [];
      this.getRolePermissions();
    },

    // 取得 角色權限
    getRolePermissions() {
      this.updateLoading(true);

      this.$api.role.getRoleMenu(this.currentRole.Name).then((response) => {
        if (response.status === 200) {
          this.menu = response.data.map((menu) => this.processMenu(menu));
        }

        this.updateLoading(false);
      });
    },

    // 處理每個 Menu 下的 Children 權限標記
    processMenu(menu) {
      const updatedChildren = menu.Children.map((permission) => {
        return {
          ...permission,
          hasPermission: this.checkPermission(permission.Permissions),
        };
      });

      return {
        ...menu,
        Children: updatedChildren,
      };
    },

    // 檢查某個權限群組中是否有任何一個 IsSelected 為 true
    checkPermission(permissions) {
      return permissions.some((p) => p.IsSelected);
    },

    // 點擊左側選單列，右側顯示擁有的權限(設定權限 Modal)
    getPermissions(subMenu) {
      this.selectedSubMenuGuid = subMenu.Guid;
      this.subMenuPermissions = subMenu.Permissions;
    },

    // 取得被選取權限的Guid
    getPermissionsGuid() {
      let subMenu = this.menu.map((item) => item.Children).flat();
      subMenu.map((item) =>
        item.Permissions.forEach((element) => {
          if (element.IsSelected === true) {
            this.selectedFeatureGuid.push(element.PermissionGuid);
          }
        })
      );
      this.saveRolePermissions();
    },

    // 儲存 角色權限
    saveRolePermissions() {
      $("#setPermissionsModal").modal("hide");
      this.updateLoading(true);
      this.$api.role
        .postRoleMenu({
          RoleGuid: this.currentRole.Id,
          PermissionGuid: this.selectedFeatureGuid,
        })
        .then((response) => {
          if (response.status === 200) {
            this.$notify({
              title: "成功",
              message: "權限設定成功",
              type: "success",
              duration: 2000,
            });
          }
          this.updateLoading(false);
          this.reload();
        });
    },

    // 設定人員 Modal
    setUserModal(role) {
      this.currentRole = role;
      this.$refs.krPaging.clearQueryInp("left");
      this.$refs.krPaging.clearQueryInp("right");
      this.leftUser = [];
      this.rightUser = [];
      this.getUser(role);
    },

    // 取得 人員資料(設定人員 Modal)
    async getUser(role) {
      this.updateLoading(true);
      const backgroundUser = await this.$api.backgroundUser.getBackgroundUser();
      const employee = await this.$api.role.getRoleMember(role.Name);

      // 取得 左側人員(後台使用者)(設定人員 Modal)
      this.leftUser = backgroundUser.data.map((user) => {
        return {
          label:
            user.Name + " (" + user.Account + ")" + " – " + user.DepartmentName,
          id: user.Account,
          filterData:
            user.Name +
            "-" +
            user.Account +
            "-" +
            user.Email +
            "-" +
            user.PhoneNumber,
        };
      });
      // 取得 右側人員(擁有此角色的人員)(設定人員 Modal)
      this.rightUser = employee.data.map((user) => {
        return {
          label:
            user.Name + " (" + user.Account + ")" + " – " + user.DepartmentName,
          id: user.Account,
          filterData:
            user.Name + "-" + user.Account + "-" + user.DepartmentName,
        };
      });
      this.updateLoading(false);
      $("#setUserModal").modal("show");
    },

    // 右側已選取人員列表
    addEmployeeToRightUser(val) {
      this.selectedUser = [];
      this.selectedUser.push(...val);
    },

    // 儲存 設定人員
    setRolesToUser() {
      $("#setUserModal").modal("hide");
      this.updateLoading(true);
      this.$api.role
        .postRoleMember({
          RoleName: this.currentRole.Name,
          Account: this.selectedUser,
        })
        .then((response) => {
          if (response.status === 200) {
            this.$notify({
              title: "成功",
              message: "儲存成功",
              type: "success",
              duration: 2000,
            });
          }
          this.updateLoading(false);
        });
    },

    // 新增、編輯 角色 Modal
    roleModal({ action, data }) {
      switch (action) {
        case "add":
          this.role = {};
          this.action = "add";
          break;
        case "edit":
          this.role = { ...data };
          this.nowRole = { ...data };
          this.action = "edit";
          break;
      }
      this.$refs.role.reset();
    },

    // 新增、編輯 角色
    saveRole() {
      $("#roleModal").modal("hide");
      let message;
      this.updateLoading(true);
      switch (this.action) {
        case "add":
          message = "新增成功";
          this.$api.role
            .postRole(JSON.stringify(this.role.Name))
            .then((response) => {
              if (response.status === 200) {
                this.$notify({
                  title: "成功",
                  message: message,
                  type: "success",
                  duration: 2000,
                });
                this.getRole();
              }
              this.updateLoading(false);
            });
          break;
        case "edit":
          message = "編輯成功";
          this.$api.role
            .putRole(JSON.stringify(this.role.Name), this.role.Id)
            .then((response) => {
              if (response.status === 200) {
                this.$notify({
                  title: "成功",
                  message: message,
                  type: "success",
                  duration: 2000,
                });
                this.getRole();
              }
              this.updateLoading(false);
            });
          break;
      }
    },

    // 刪除 角色
    delRole() {
      this.updateLoading(true);
      this.$api.role.deleteRole(this.role.Id).then((response) => {
        if (response.status === 200) {
          this.$notify({
            title: "成功",
            message: "刪除成功",
            type: "success",
            duration: 2000,
          });
          this.getRole();
        }
        this.updateLoading(false);
      });
    },

    // loading
    ...mapActions(["updateLoading"]),

    // 多國語系
    i18n(keyStr) {
      return this.$t(keyStr);
    },
  },

  destroyed() {
    $(".modal").modal("hide");
    $("body").removeClass("modal-open");
    $(".modal-backdrop").remove();
    this.$notify.close();
  },
};
</script>

<style lang="scss" scoped>
/deep/ .district-panel .no-data {
  color: transparent !important;
  font-size: 0 !important;

  &::before {
    content: "無數據";
    color: #909399 !important;
    font-size: 14px !important;
  }
}
#setUserModal {
  @media (max-width: 850px) {
    .modal-dialog {
      max-width: 97%;

      /deep/ .opera {
        width: 50px;
      }
    }
  }
}
</style>
